import { prisma } from "@/lib/db";

/**
 * Normalize answer for comparison
 */
export function normalizeAnswer(input: string): string {
  return input.trim().toLowerCase();
}

/**
 * Check if answer is correct
 */
export function checkAnswer(userInput: string, correctAnswer: string): boolean {
  return normalizeAnswer(userInput) === normalizeAnswer(correctAnswer);
}

/**
 * Update problem state after a review
 */
export async function updateStateAfterAnswer(
  userId: string,
  problemId: string,
  wasCorrect: boolean
): Promise<void> {
  const now = new Date();

  await prisma.userProblemState.upsert({
    where: {
      userId_problemId: {
        userId,
        problemId,
      },
    },
    update: {
      lastAnsweredAt: now,
      lastResult: wasCorrect ? "correct" : "wrong",
    },
    create: {
      userId,
      problemId,
      set: "focus", // New problems start in focus
      lastAnsweredAt: now,
      lastResult: wasCorrect ? "correct" : "wrong",
    },
  });
}
